import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isCountryGB } from '../../../../brands/default/config';
import { DEAL_CHOOSE_YOUR_OPTIONS_CLAIM_MESSAGE_COMPONENT } from '../../../../brands/default/content/components/deal';
import { formatCurrency } from '../../../../helpers/currency';
import { getWallet } from '../../../../redux/actions/wallet';
import Message from '../../../_generic/Message';

const DealChooseYourOptionsClaimMessage = ({
  selectedOptions = [],
  deal = {},
}) => {
  const dispatch = useDispatch();
  const [userWallet, isAuthenticated] = useSelector((state) => [
    state.wallet.userWallet,
    state.user.isAuthenticated,
  ]);

  useEffect(() => {
    dispatch(getWallet());
  }, [dispatch, isAuthenticated]);

  if (!userWallet || !isAuthenticated) return null;

  const userBalance =
    userWallet[isCountryGB ? 0 : 1]?.balanceWithValidExperienceCredit;

  const sumWithSingleSelectDeals = deal?.price;
  const sumWithInitial = selectedOptions.reduce(
    (previousValue, currentValue, currentIndex) => {
      if (currentValue > 0) {
        return previousValue + deal.products[currentIndex].price * currentValue;
      }

      return previousValue;
    },
    0,
  );

  const sum =
    selectedOptions?.length > 0 ? sumWithInitial : sumWithSingleSelectDeals;
  if (userBalance >= sum) return null;

  const payExtra = formatCurrency(
    deal?.currency,
    sum - userBalance,
    false,
    true,
  );

  return (
    <Message
      message={DEAL_CHOOSE_YOUR_OPTIONS_CLAIM_MESSAGE_COMPONENT.giftPackUpgrade(
        payExtra,
      )}
      showIcon={false}
      type="INFO"
    />
  );
};

DealChooseYourOptionsClaimMessage.propTypes = {
  deal: PropTypes.object,
  selectedOptions: PropTypes.array,
};

export default DealChooseYourOptionsClaimMessage;
